import { createSlice } from '@reduxjs/toolkit';

export const assistantsSlice = createSlice({
  name: 'assistants',
  initialState: {
    assistant_list: [],
    assistant: {},
    form_options: [],
    form_options_ia_skills_checkbox: [],
    plan_info: {},
  },
  reducers: {
    setAssistantsListRedux: (state, { payload }) => {
      state.assistant_list = payload;
    },
    setAssistantRedux: (state, { payload }) => {
      state.assistant = payload;
    },
    setFormOptionsRedux: (state, { payload }) => {
      state.form_options = payload;
    },
    setFormOptionsIaSkillsRedux: (state, { payload }) => {
      state.form_options_ia_skills_checkbox = payload;
    },
    setPlanInfoRedux: (state, { payload }) => {
      state.plan_info = payload;
    },
  },
});

export const {
  setAssistantsListRedux,
  setAssistantRedux,
  setFormOptionsRedux,
  setFormOptionsIaSkillsRedux,
  setPlanInfoRedux,
} = assistantsSlice.actions;
